import React from "react";
import ExpressOnBoarding from "./express/ExpressOnBoarding";
import useFeatureToggles from "../../common/hooks/useFeatureToggles";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import useOnBoarding from "src/core/checkout/hooks/useOnBoarding";
import useRouter from "../../common/hooks/useRouter";
import routes from "../../common/routes";
import useDeliveryType from "src/core/deliveries/hooks/useDeliveryType";
import useInventoryType from "src/core/inventories/useInventoryType";

const AllBoardings = [ExpressOnBoarding];

export function RequiresOnBoarding({render, onSuccessGoTo}) {
  const toggles = useFeatureToggles();
  const [, Auth] = useAuthentication();
  const [onBoardingState] = useOnBoarding();
  const router = useRouter();
  const {data} = onBoardingState;
  const [deliveryType] = useDeliveryType();
  const [inventoryType] = useInventoryType();

  const anyOnBoardingRequired = () =>
    AllBoardings.filter(
      onBoarding =>
        onBoarding.isEnabled(toggles) &&
        !onBoarding.isDone({loggedIn: Auth.isLoggedIn(), onBoardingStateData: data})
    ).length > 0;

  const requiresOnBoarding =
    !toggles.registrationOptional({inventoryType, deliveryType}) &&
    anyOnBoardingRequired();

  function start() {
    if (!requiresOnBoarding) {
      router.push(onSuccessGoTo);
    } else {
      router.push({
        pathname: routes.onBoarding,
        query: {redirect: onSuccessGoTo},
      });
    }
  }

  return <>{render && render({start})}</>;
}

function CheckoutOnBoardingModal({isOpen, closeModal, options}) {
  const router = useRouter();
  const {redirect} = router.query;
  const toggles = useFeatureToggles();
  const onBoardings = AllBoardings.filter(onBoarding => onBoarding.isEnabled(toggles));

  function onSuccess() {
    if (redirect) {
      router.replace(redirect);
    } else {
      closeModal();
    }
  }

  return (
    <ControlledCheckoutOnBoarding
      onSuccess={onSuccess}
      inProgress={isOpen}
      editing={false}
      onStop={closeModal}
      options={options}
      onBoardings={onBoardings}
    />
  );
}

function ControlledCheckoutOnBoarding({
  onSuccess,
  onStop,
  inProgress,
  render,
  onBoardings,
  options,
}) {
  return (
    <>
      {inProgress &&
        onBoardings.map((Component, index) => (
          <Component
            onSuccess={onSuccess}
            inProgress={inProgress}
            closeOnBoarding={onStop}
            options={options}
            key={index}
          />
        ))}
      {render && render()}
    </>
  );
}

export default CheckoutOnBoardingModal;
